import React, { forwardRef } from "react";
import { cn } from "../../lib/utils";

const Card = forwardRef(
  ({ className, variant = "default", children, ...props }, ref) => {
    const variants = {
      default: cn("bg-paper", "border border-border"),
      elevated: cn(
        "bg-paper",
        "shadow-md hover:shadow-lg",
        "border border-border/50"
      ),
      bordered: cn(
        "bg-paper",
        "border-2 border-border-dark",
        "relative",
        // Art Deco corner accents
        "before:absolute before:top-0 before:left-0 before:w-6 before:h-6",
        "before:border-t-2 before:border-l-2 before:border-gold",
        "after:absolute after:bottom-0 after:right-0 after:w-6 after:h-6",
        "after:border-b-2 after:border-r-2 after:border-gold"
      ),
    };

    return (
      <div
        ref={ref}
        className={cn(
          // Base styles
          "overflow-hidden",
          "transition-all duration-300",
          // Variant
          variants[variant],
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Card.displayName = "Card";

// Card subcomponents
const CardHeader = forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("px-6 py-4 border-b border-border", className)}
    {...props}
  />
));
CardHeader.displayName = "CardHeader";

const CardContent = forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("px-6 py-4", className)} {...props} />
));
CardContent.displayName = "CardContent";

const CardFooter = forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("px-6 py-4 border-t border-border", className)}
    {...props}
  />
));
CardFooter.displayName = "CardFooter";

export { Card, CardHeader, CardContent, CardFooter };
